import { Chip, type ChipProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

import type { ChipTone } from "@/theme/theme";

export interface AppChipProps extends Omit<ChipProps, "color" | "variant"> {
  tone: ChipTone;
}

/** A semantic chip with a shared background, border, text, and icon treatment. */
export const AppChip: React.FC<AppChipProps> = ({ tone, sx, ...props }) => {
  const theme = useTheme();
  const colors = theme.chipTones[tone];

  return (
    <Chip
      {...props}
      sx={[
        {
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,
          color: colors.text,
          "& .MuiChip-icon, & .MuiChip-deleteIcon": { color: colors.text },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};
